
<highcharts :options="chartOptions"></highcharts>
